// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__PYj6c","notes":"Notes_notes__2TAbd"};